import { Menu, styled } from '@mui/material';

const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    '& .MuiMenuItem-root': {
      display: 'flex',
      gap: 8,
      padding: '6px 12px',
      minHeight: 0,

      '& .MuiListItemButton-root': {
        display: 'flex',
        gap: 8,
      },
    },
  },
});

export default StyledMenu;
